import React, { useState, useRef } from "react";
import {
  useRequestHistory,
  useStatusHistory
} from "protocol-setup/redux/useLovs";
import { titleAndAria } from "protocol-setup/constants/errorMessages";
import RequestHistory from "./RequestHistory";

const RequestHistoryButton = ({ requestNumber, formPartType, icon, disabled }) => {
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const buttonRef = useRef(null);
  const {
    requestHistory,
    isLoadingRequestHistory,
    error,
    triggerRequestHistory
  } = useRequestHistory(requestNumber);
  const {
    statusHistory,
    isLoadingStatusHistory,
    error: statusError,
    triggerStatusHistory
  } = useStatusHistory(requestNumber);

  const handleOpenHistory = () => {
    setShowHistoryModal(true);
    triggerRequestHistory();
    triggerStatusHistory();
  };

  const handleCloseHistory = () => {
    setShowHistoryModal(false);
    if (buttonRef.current) {
      setTimeout(() => {
        buttonRef.current.focus();
      }, 0);
    }
  };

  return (
    <div>
      <button
        ref={buttonRef}
        type="button"
        className="btn mx-1"
        onClick={handleOpenHistory}
        title={titleAndAria.viewRequestHistory(requestNumber)}
        disabled={disabled}
      >
        <span data-requestnumber={`${requestNumber}-history`} className="summary-bar-key">
          {icon}
        </span>
        View History
      </button>

      {/* Request History Modal - Uses the organized folder structure */}
      <RequestHistory
        formPartType={formPartType} // e.g., "OPEN_RAVE" or "REGULATORY"
        requestNumber={requestNumber}
        isOpen={showHistoryModal}
        onClose={handleCloseHistory}
        requestHistory={requestHistory}
        isLoading={isLoadingRequestHistory}
        error={error}
        statusHistory={statusHistory}
        isLoadingStatusHistory={isLoadingStatusHistory}
        statusError={statusError}
      />
    </div>
  );
};

export default RequestHistoryButton;
